import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TAgent } from '../types/agent.type';

/**
 *
 */
export const SetAsAdminValidationSchema = z.object({
  agentId: z.string(),
});
export type TSetAsAdminValidation = z.infer<typeof SetAsAdminValidationSchema>;
export type TSetAsAdminPayload = TSetAsAdminValidation;
export type TSetAsAdminResponse = ApiResponse<TAgent>;

export const setAsAdmin = async (payload: TSetAsAdminPayload): Promise<TSetAsAdminResponse> => {
  const url = `/user/manage/set-as-admin/${payload.agentId}`;

  return axiosInstance.patch(url);
};

/**
 * Return query key for set as admin
 */
type UseSetAsAdminOptions = {
  mutationConfig?: TypedMutationConfig<typeof setAsAdmin, AxiosErrorCustom>;
};

export const useSetAsAdmin = ({ mutationConfig }: UseSetAsAdminOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation<TSetAsAdminResponse, AxiosErrorCustom, TSetAsAdminPayload>({
    mutationFn: setAsAdmin,
    ...restConfig,
  });
};
